import { render } from "./About.vue?vue&type=template&id=ba3680c0"
const script = {}
script.render = render

export default script